import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectIsCockpitFilterDirty = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) =>
    filter.geoMappings.length > 0 ||
    filter.amplifyMemberships.length > 0 ||
    filter.partnerClasses.length > 0 ||
    filter.mdfStatus !== 'All' ||
    filter.plannedStatus !== 'All' ||
    filter.mandatoryStatus !== 'All' ||
    filter.selectedPartnerIds.length > 0 ||
    filter.pbm.length > 0 ||
    filter.manager.length > 0 ||
    filter.globalPartners.length > 0
)
